import { ReplicaType } from "types";
import Version1 from "./v1";
import Version2 from "./v2";
import replicaCategories from "assets/replicas/_categories";

const data: ReplicaType = {
  id: "daily-prophet-hp5-he-who-must-not-be-named-returns",
  name: `The Daily Prophet\n'He Who Must Not Be Named Returns'`,
  nameFormatted: {
    primary: "The Daily Prophet",
    secondary: "'He Who Must Not Be Named Returns'",
  },
  origin: "Harry Potter and the Order of the Phoenix",

  category: replicaCategories.harryPotter,

  versions: [Version2, Version1],
};

export default data;
